import { Box } from "@/components/ui/box";
import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { ComponentProps, createContext, useContext } from "react";
import { WebHeader } from "../menu/web.header";
import { WebSidebar } from "../menu/web.sidebar";
import { Platform } from "react-native";
import { Tabs } from "expo-router";

export type TabLayoutProps = ComponentProps<
  NonNullable<ComponentProps<typeof Tabs>["layout"]>
>;

const TabLayoutContext = createContext<
  Omit<TabLayoutProps, "children"> | undefined
>(undefined);

export function useTabLayoutContext() {
  const ctx = useContext(TabLayoutContext);

  if (!ctx) {
    throw new TypeError(
      "Use of layout context possible only inside TabLayoutContext"
    );
  }

  return ctx;
}

export function TabLayout({ children, ...rest }: TabLayoutProps) {
  if (Platform.OS === "web") {
    return (
      <VStack className="h-full w-full bg-background-0">
        <Box className="hidden md:flex">
          <WebHeader />
        </Box>
        <HStack className="h-full w-full max-w-screen-xl self-center">
          <Box className="hidden md:flex h-full min-w-56">
            <WebSidebar {...rest} />
          </Box>
          <TabLayoutContext.Provider value={rest}>
            {children}
          </TabLayoutContext.Provider>
        </HStack>
      </VStack>
    );
  } else {
    return (
      <TabLayoutContext.Provider value={rest}>
        {children}
      </TabLayoutContext.Provider>
    );
  }
}
